import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WbsAccountRequestDto } from 'src/api/FiretrolApiClient';
import { wbsApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useWbsAccountMutations(jobId: number) {
  const qc = useQueryClient();
  const settle = () => invalidateFor('wbsAccount.save', qc, { jobId });

  const createAccount = useMutation({
    mutationFn: ({
      wbsId,
      request,
    }: {
      wbsId: string;
      request: WbsAccountRequestDto;
    }) => wbsApiClient.createAccount(wbsId, request),
    onSettled: settle,
  });

  const updateAccount = useMutation({
    mutationFn: ({
      accountId,
      request,
    }: {
      accountId: string;
      request: WbsAccountRequestDto;
    }) => wbsApiClient.updateAccount(accountId, request),
    meta: { successMessage: 'Account saved successfully!' },
    onSettled: settle,
  });

  const deleteAccount = useMutation({
    mutationFn: (accountId: string) => wbsApiClient.deleteAccount(accountId),
    onSettled: settle,
  });

  return { createAccount, updateAccount, deleteAccount };
}
